<template>
    <div :class="[{ sm }, { 'h-100': !!title }, { container: containerMode || !!pageTitle }]">
        <div
            :class="[
                'card-container',
                { 'card-space-between': spaceBetween },
                { 'normal-mode': !!title },
                { 'page-mode': !!pageTitle },
                { dark: theme == THEMES.DARK },
            ]"
        >
            <div v-if="title">
                <div class="header-title">
                    <div class="title mb-3">{{ title }}</div>
                    <slot name="headerside"></slot>
                </div>
                <!-- <hr style="color: #888" :class="[{ 'my-3': !sm }, { 'my-2': sm }]" /> -->
            </div>
            <slot />
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex"

export default {
    props: {
        spaceBetween: { type: Boolean, default: true },
        containerMode: { type: Boolean, default: false },
        pageTitle: { type: String, default: "" },
        title: { type: String, default: "" },
        fullWidth: { type: Boolean, default: false },
        sm: { type: Boolean, default: false },
    },
    mounted() {
        if (this.pageTitle) {
            this.setData({
                pageTitle: this.pageTitle,
            })
        }
    },
    methods: {
        ...mapActions("misc", ["setData"]),
    },
    watch: {
        pageTitle(e) {
            this.setData({
                pageTitle: this.pageTitle,
            })
        },
    },
    computed: {
        ...mapState("misc", ["theme", "THEMES"]),
    },
}
</script>

<style lang="scss">
@import "@/assets/variables.scss";

.card-container {
    background-color: $lightCardBg;
    box-shadow: $cardShadow;
    padding: $cardPaddingY $cardPaddingX;
    border-radius: $cardRadius;
    display: flex;
    flex-flow: column;
    height: 100%;
    border: 1px solid $lightBorderColor;
    transition: all 0.2s ease-in-out;
    
    &:hover {
        box-shadow: $cardShadowHover;
    }
    
    &.card-space-between {
        justify-content: space-between;
    }
    
    .title {
        font-size: 18px;
        font-weight: 600;
        color: $primaryColor;
    }

    .normal-mode {
        justify-content: flex-start;
    }
    
    &.dark {
        background: $darkCardBg;
        border-color: $darkBorderColor;
        box-shadow: none;
        color: $darkTextColor;
        
        .title { color: $secondaryColorDark; }
        
        &:hover { box-shadow: none; }
    }
}

.sm .card-container {
    padding: $cardPaddingY $cardPaddingX;
    .title {
        font-size: 16px;
    }
}

.page-mode {
    min-height: 400px;
}

.header-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid $lightBorderColor;
    
    .dark & {
        border-bottom-color: $darkBorderColor;
    }
}
</style>
